import * as modules from "./modules/";
import config from "../../../../config";

const { vendor } = config;

const BannerCheckList = modules[vendor] ? modules[vendor] : modules["default"];

export default BannerCheckList;
